import { render, staticRenderFns } from "./Line-Item-NewV2.vue?vue&type=template&id=09456ecc&scoped=true"
import script from "./Line-Item-NewV2.vue?vue&type=script&lang=js"
export * from "./Line-Item-NewV2.vue?vue&type=script&lang=js"
import style0 from "./Line-Item-NewV2.vue?vue&type=style&index=0&id=09456ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09456ecc",
  null
  
)

export default component.exports